/**
 * CountryEnum
 */
export enum CountryEnum {
  ECU = "Ecuador",
  COL = "Colombia",
  PER = "Peru",
  CHL = "Chile",
  MXN = "Mexico",
  BRA = "Brazil",
  CRI = "Costa Rica",
}

export const COUNTRY_ISO_CODE: Record<CountryEnum, string> = {
  [CountryEnum.ECU]: "EC",
  [CountryEnum.COL]: "CO",
  [CountryEnum.PER]: "PE",
  [CountryEnum.CHL]: "CL",
  [CountryEnum.MXN]: "MX",
  [CountryEnum.BRA]: "BR",
  [CountryEnum.CRI]: "CR",
};
